
import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { EntityLineHeader } from '../../entity/entity-line-header';
import { WarrantyLineService } from '../../services/warranty-line.service';
import { OrganizationAddressService } from '../../services/organization-address-service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SerialNumberResearchService } from '../../services/serial-number-research.service';
import { WarrantyLine } from '../../model/warranty-line';
import { DefectCode } from '../../model/defect-code';

@Component({
  selector: 'warranty-line-summary-dialog',
  templateUrl: './warranty-line-summary-dialog.component.html',
  styleUrls: ['./warranty-line-summary-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatDialogActions, MatButton, MatProgressSpinnerModule]
})
export class WarrantyLineSummaryDialogComponent {
  private readonly serialNumberResearchService = inject(SerialNumberResearchService);
  private readonly addressService = inject(OrganizationAddressService);
  private readonly warrantyLineService = inject(WarrantyLineService);
  readonly dialogRef = inject<MatDialogRef<WarrantyLineSummaryDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  isBusy: boolean;
  public entityLine: EntityLineHeader;
  public readonly displayAddress = signal<string>(undefined!);
  public readonly warrantyLine = signal<WarrantyLine>(undefined!);
  public readonly defectDescription = signal<string>(undefined!);

  constructor
    () {
    const data = this.data;

    this.entityLine = data.line as EntityLineHeader;
    this.isBusy = true;
    this.warrantyLineService.getWarrantyLine(this.entityLine.key.entityId, this.entityLine.key.entityRevision, this.entityLine.lineId).subscribe({
      next: (warrantyLine: WarrantyLine) => {
        if (warrantyLine) {
          this.warrantyLine.set(warrantyLine);
          this.serialNumberResearchService.getDefectCodesOrDefault(this.entityLine.prn).subscribe({
            next: (result: DefectCode[]) => this.defectDescription.set(result.filter(code => code.id === this.warrantyLine().defectCodeId)[0]?.description || 'Unknown'),
          });
        }
      },
    });
    this.addressService.getAddress(this.data?.dealerAddressId).subscribe({
      next: (address) => {
        const parts: string[] = [];
        const isValid = (val: string | null | undefined): boolean =>
          !!val && val.trim() !== ".";
        parts.push(address.attentionLine);
        if (isValid(address.addressLine1)) parts.push(address.addressLine1);
        if (isValid(address.addressLine2)) parts.push(address.addressLine2);
        if (isValid(address.addressLine3)) parts.push(address.addressLine3);
        const cityStateZip = [
          address.cityName,
          address.stateCode,
          address.postalCode
        ].join(' ');
        if (cityStateZip) parts.push(cityStateZip);
        if (isValid(address.countryCode)) parts.push(address.countryCode);
        this.displayAddress.set(parts.join('\n'));
      },
    });
    this.isBusy = false;
  }

  public close(): void {
    this.dialogRef.close(null);
  }

}
